import {CCol, CRow } from '@coreui/react';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import LoadingButton from "../../shared/components/LoadingButton";
import { selectUserProfile } from '../../store/selectors/profile.selectors';
import { LoadOrg } from '../../store/actions/orgHierarchy.action';

const AccountBillingComplete = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const profile = useSelector(selectUserProfile);

  const updateBillingInfo = () => {
    dispatch(new LoadOrg(profile.orgId));
    history.push('/dashboard');
  };
  return (
    <CRow>
      <CCol className="flex-column flex-center">
        <h1 className="text-center">Your Account Setup is Complete</h1>
        <p className="text-center">Awesome! Your account setup is complete. Now it’s time to add your workers and create jobs!</p>
        <p className="text-center">If you would like to learn more about Glympse PRO, check out our help and support documentation at <a
          href="https://glympse.zendesk.com/hc/en-us" target="_blank" rel="noreferrer">Glympse Support</a>.</p>
        <p className="text-center">You may also find our video tutorials helpful.</p>
        <p className="text-center">Now that you are all set, head on over to your account dashboard to get started using Glympse PRO for your business today.</p>
        <LoadingButton
          size="lg"
          className="bg-color-orange border-0"
          isLoading={false}
          onClick={updateBillingInfo}
        >
          Go to Account Dashboard
        </LoadingButton>
      </CCol>
    </CRow>
  );
};

export default AccountBillingComplete;
